import React from 'react';
import '../../../Assets/Css/EmpAttendanceDetails.scss';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Map from "../../../Assets/Images/Attendance/map-person.svg"
import AttendancebyHour from "../../../Assets/Images/Attendance/AttendancebyHour"
import "/node_modules/flag-icons/css/flag-icons.min.css";
import moment from 'moment';
import { FaUserCircle } from 'react-icons/fa';
import UserAvatar from 'react-user-avatar';
import { IoClose } from "react-icons/io5";



const EmpAttendanceDetails = (props) => {
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const userData = location?.state?.dayDetails?.records?.[0]?.user || location?.state?.data?.dayDetails?.records?.[0]?.user;
  const dayDetails = location?.state?.dayDetails?.records || location?.state?.data?.dayDetails?.records;
  const userProfilePic = localStorage.getItem('userProfilePic');


  const totalDuration = moment.duration();

  dayDetails?.forEach(item => {
    const inTime = moment(item?.clock_in, 'HH:mm:ss');
    const outTime = item?.clock_out
      ? moment(item?.clock_out, 'HH:mm:ss')
      : moment(item?.date).isSame(moment(), 'day')
        ? moment()
        : moment(item?.date, 'HH:mm:ss').endOf('day')

    if (inTime.isValid() && outTime.isValid()) {
      const duration = moment.duration(outTime.diff(inTime));
      totalDuration.add(duration);
    }
  });

  const hours = Math.floor(totalDuration.asHours());
  const minutes = totalDuration.minutes();

  const events = [
    {
      id: 1,
      date: moment(dayDetails?.[0]?.date).format('DD-MM-YYYY'),
      day: moment(dayDetails?.date).format('dddd'),
      status: 'Present',
      clockTimes: dayDetails?.map((item) => ({
        clockIn: moment(item?.clock_in, 'HH:mm:ss').format('hh:mm A'),
        clockOut: item?.clock_out ? moment(item?.clock_out, 'HH:mm:ss').format('hh:mm A') : "Did not clock out",
        location: item.city || "N/A",
        workType: 'Office'
      })),
      total: `${hours}h ${minutes}m`,
      location: ''
    }
  ]

  return (
    <div className='attendance-table p-0'>
      <div className="attandance_details_header">
        <div className='px-4 pt-2'>
        </div>
        <div className="edit-btn">
          <button
            type="submit"
            className="close-btn"
            onClick={() => navigate(-1)}
          ><IoClose /></button>
        </div>
      </div>

      <div className="attendance-page">
        <div className='row'>

          <div className='col-lg-12 col-md-12 col-sm-12'>
            <div className="header-section">
              {userProfilePic ? (
                <img
                  src={userProfilePic}
                  alt="Profile"
                  className="profile-pic me-3"
                />
              ) : (
                <UserAvatar name={userData?.name} size={40} style={{ textTransform: 'uppercase', color: 'white' }} color="#5757fe" />
                // <FaUserCircle size={50} color="rgb(180, 180, 180)" />
              )}
              <div style={{ marginLeft: '10px' }}>
                <h4 className="m-0">{userData?.name} <span class={`fi fi-${userData?.country?.toLowerCase()?.split('')?.[0] + userData?.country?.toLowerCase()?.split('')[1]}`}></span></h4>
                <p className="m-0">{userData?.designation?.name}</p>
              </div>
            </div>
          </div>

          <div className='col-lg-6 col-md-6 col-sm-12'>
            <div className="content-section">
              <div className='row'>
                <div className='col-lg-12 date'>
                  <h5>Date - {moment(dayDetails?.[0]?.date).format('DD-MM-YYYY')}</h5>
                </div>

                <div className='clockinbox'>
                  <p>Clock In</p>
                  <h6>{moment(dayDetails?.[0]?.clock_in, 'HH:mm:ss').format('hh:mm A')}</h6>
                </div>

                <div className="clock-time-circle">
                  <span>{`${hours}h ${minutes}m`}</span>
                </div>

                <div className='clockinbox'>
                  <p>Clock Out</p>
                  <h6>
                    {dayDetails?.[dayDetails?.length - 1]?.clock_out
                      ? moment(dayDetails?.[dayDetails?.length - 1]?.clock_out, 'HH:mm:ss').format('hh:mm A')
                      : (
                        moment(
                          dayDetails?.[dayDetails?.length - 1]?.date
                        ).isSame(moment(), 'day')
                          ? moment()?.format('hh:mm A')
                          : moment(dayDetails?.[dayDetails?.length - 1]?.date, 'YYYY-MM-DD')
                            .endOf('day')
                            .format('hh:mm A')
                      )}
                    {!dayDetails?.[dayDetails?.length - 1]?.clock_out && ' (Did not clock out)'}
                  </h6>
                </div>

              </div>
            </div>
          </div>

          <div className='col-lg-6 col-md-6 col-sm-12'>
            <div id="content" className='activity'>
              <ul className="timeline">
                {events?.map((item1, index) => (
                  <>
                    {item1?.clockTimes?.map((item, i) => (
                      <li className="event" key={i}>
                        <div>
                          <h3>Clock In</h3>
                          <div className='clockin-comp'>
                            <h6>
                              <AttendancebyHour />
                              {' '}{item1.date}
                            </h6>
                            <h6>
                              {item.clockIn}
                            </h6>
                            <h6>
                              <img src={Map} alt='map' />
                              {`${item.location}`}
                            </h6>
                            <h6>
                              {item1.status}
                            </h6>
                          </div>
                        </div>
                        <div className='mt-4'>
                          <h3>Clock out</h3>
                          <div className='clockin-comp '>
                            <h6>
                              <AttendancebyHour />
                              {' '}{item1.date}
                            </h6>
                            <h6>
                              {item.clockOut || `Did not clock out`}
                            </h6>
                          </div>
                        </div>
                      </li>
                    ))}
                  </>
                ))}
              </ul>
            </div>
          </div>

        </div>
      </div>

    </div>
  );
};

export default EmpAttendanceDetails;
